module.exports = __webpack_public_path__ + "img/cdm-platform-min.786946a5.png";